<template>
  <div class="dashboard-page">
    <!-- <el-header>
      <h1>Dashboard</h1>
    </el-header> -->
    <detail-container>
      <el-row
        :gutter="20"
        justify="center"
      >
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
        >
          <WidgetSolicitudes />
        </el-col>
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
        >
          <WidgetPropuestas />
        </el-col>
        <el-col
          :xs="24"
          :sm="24"
          :md="8"
          :lg="6"
        >
          <WidgetClientes />
        </el-col>
      </el-row>
      <el-row
        :gutter="20"
        justify="center"
      >
        <el-col
          :xs="24"
          :lg="18"
          class="dashboard-charts-col"
        >
          <WidgetContainer>
            <template v-slot="{ filters }">
              <el-row :gutter="20">
                <el-col
                  :xs="24"
                  :md="12"
                >
                  <WidgetEstadosCotizacion :filters="filters" />
                </el-col>
                <el-col
                  :xs="24"
                  :md="12"
                >
                  <WidgetVentas :filters="filters" />
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col
                  :xs="24"
                  :md="12"
                >
                  <WidgetRankingVendedores :filters="filters" />
                </el-col>
                <el-col
                  :xs="24"
                  :md="12"
                >
                  <WidgetVentasPorProducto :filters="filters" />
                </el-col>
              </el-row>
            </template>
          </WidgetContainer>
        </el-col>
      </el-row>
    </detail-container>
  </div>
</template>

<script setup>
import 'vue-data-ui/style.css';
import DetailContainer from '@/shared/layout/detail/detail_container.vue';
import WidgetSolicitudes from './widgets/solicitudes.vue';
import WidgetPropuestas from './widgets/propuestas.vue';
import WidgetClientes from './widgets/clientes.vue';
import WidgetEstadosCotizacion from './widgets/estados_cotizacion.vue';
import WidgetVentas from './widgets/ventas.vue';
import WidgetContainer from './widgets/container.vue';
import WidgetRankingVendedores from './widgets/ranking_vendedores.vue';
import WidgetVentasPorProducto from './widgets/ventas_por_producto.vue';
</script>

<style scoped>
.dashboard-page {
  height: 100%;
  overflow: auto;
  display: flex;
}

.dashboard-charts-col {
  padding: 20px;
}

/* Mobile: las tarjetas se apilan a todo el ancho (antes span fijo de 6/24 las aplastaba) */
@media (max-width: 767px) {
  .dashboard-page {
    min-width: 0;
  }

  .dashboard-page :deep(.detail_container) {
    padding: 10px;
    min-width: 0;
  }

  .dashboard-charts-col {
    padding: 10px 0;
  }
}
</style>
